import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import MasterCodeMaintenanceContMain from "presentation/view/container/MasterCode/MasterCodeContMain";

CommonEntrypoint(<MasterCodeMaintenanceContMain/>)